<header class="app-header">
  <img
    class="app-header-logo"
    src="assets/schaeffler-logo.svg"
    alt="Schaeffler"
  />

  <button
    type="button"
    class="app-header-user"
    (click)="toggleMenu.emit()"
    [attr.aria-expanded]="userMenuOpen()"
    aria-haspopup="true"
    [attr.aria-label]="userMenuAriaLabel()"
  >
    <div class="app-header-avatar" aria-hidden="true">{{ initials() }}</div>
    <span class="app-header-username">{{ username() }}</span>
    <svg
      class="app-header-chevron"
      [class.open]="userMenuOpen()"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M4 6l4 4 4-4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>

  @if (userMenuOpen()) {
    <button
      type="button"
      class="app-header-menu-backdrop"
      (click)="closeMenu.emit()"
      [attr.aria-label]="closeMenuAriaLabel()"
    ></button>
    <div class="app-header-menu" role="menu">
      <a
        routerLink="/logout"
        class="app-header-menu-item"
        role="menuitem"
        (click)="closeMenu.emit()"
      >
        {{ logoutLabel() }}
      </a>
    </div>
  }
</header>
